import z from "zod";

const truckIsTruckArgsSchema = z.object({
  plate: z.string().min(7).max(7)
});

export { truckIsTruckArgsSchema };
